import { render, staticRenderFns } from "./PreprojectsRevision.vue?vue&type=template&id=5fd3bdec&"
import script from "./PreprojectsRevision.vue?vue&type=script&lang=js&"
export * from "./PreprojectsRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports